import { TmrBaseResource } from 'stylewhere/api'

export class Printers extends TmrBaseResource {
  static endpoint = 'edge/api/v1/printers'
}
